import UikitInput from "./Input.vue.es.js";
import { toRef, resolveComponent, openBlock, createElementBlock, createVNode, withKeys, withModifiers, createSlots, withCtx, renderSlot, Transition, withDirectives, createElementVNode, normalizeStyle, Fragment, renderList, mergeProps, toDisplayString, normalizeClass, vShow } from "vue";
import { useField } from "vee-validate";
/* empty css                     */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-autocomplete",
  components: { UikitInput },
  $emits: ["update:modelValue", "onQueryUpdate"],
  props: {
    delay: {
      type: Number,
      default: 250
    },
    hint: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    legend: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    rules: {
      type: [String, Object],
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    search: {
      type: Function,
      default: () => () => []
    },
    variant: {
      type: String,
      default: "old"
    },
    modelValue: {
      type: [String, Number, Object],
      default: () => {
      }
    },
    selectable: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const name = toRef(props, "name");
    const {
      value: query,
      errorMessage,
      handleBlur: handleFieldBlur,
      handleChange: handleFieldChange
    } = useField(name, props.rules, {
      initialValue: props.defaultValue,
      syncVModel: false,
      validateOnValueUpdate: false
    });
    return { query, errorMessage, handleFieldBlur, handleFieldChange };
  },
  data: () => {
    return {
      highlightElementIndex: -1,
      isFocuses: false,
      previousQuery: "",
      options: [],
      panelStyles: {
        top: 0,
        right: 0,
        width: 0
      },
      timeout: null
    };
  },
  computed: {
    highlightElement() {
      if (this.highlightElementIndex >= 0) {
        return this.options[this.highlightElementIndex];
      } else {
        return null;
      }
    },
    isPanelOpened() {
      return this.options.length && this.isFocuses;
    }
  },
  watch: {
    isPanelOpened() {
      this.drawPanel();
    },
    defaultValue(defaultValue) {
      this.query = defaultValue;
    }
  },
  mounted() {
    if (this.defaultValue) {
      this.query = this.defaultValue;
    }
    window.addEventListener("resize", this.drawPanel);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.drawPanel);
  },
  methods: {
    drawPanel() {
      if (this.isPanelOpened) {
        const input = this.$refs.inner.$el;
        const width = input.clientWidth;
        const height = input.clientHeight + 10;
        this.panelStyles = { top: `${height}px`, right: 0, width: `${width}px` };
      }
    },
    blur() {
      this.$refs.inner.blur();
    },
    focus() {
      this.$refs.inner.focus();
    },
    handleFocus() {
      this.isFocuses = true;
    },
    handleBlur() {
      this.isFocuses = false;
      this.highlightElementIndex = -1;
    },
    async handleSearch($event) {
      if ($event.key === "Enter") {
        $event.preventDefault();
        $event.stopPropagation();
      }
      if (this.previousQuery !== this.query) {
        this.$emit("onQueryUpdate", this.query);
        this.previousQuery = this.query;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(async () => {
          if (this.query.length) {
            this.highlightElementIndex = -1;
            const options = await this.search(this.query);
            this.options = options.slice(0, 5);
          } else {
            this.options = [];
          }
        }, this.delay);
      }
    },
    handleUpSearch() {
      if (!this.selectable) {
        return;
      }
      this.highlightElementIndex -= 1;
      if (this.highlightElementIndex < 0) {
        this.highlightElementIndex = this.options.length - 1;
      }
    },
    handleDownSearch() {
      if (!this.selectable) {
        return;
      }
      this.highlightElementIndex += 1;
      if (this.highlightElementIndex > this.options.length - 1) {
        this.highlightElementIndex = 0;
      }
    },
    handleSelection(selection, $event) {
      if (selection && this.selectable) {
        $event.preventDefault();
        $event.stopPropagation();
        this.options = [];
        this.highlightElementIndex = -1;
        this.handleFieldChange(selection.label);
        this.$emit("update:modelValue", selection);
      }
      if ($event.code === "Enter") {
        this.$emit("onKeydownEnter");
      }
    }
  }
};
const _hoisted_1 = { class: "autocomplete" };
const _hoisted_2 = { class: "label" };
const _hoisted_3 = ["onMouseup"];
const _hoisted_4 = { class: "label" };
const _hoisted_5 = ["onMouseup"];
const _hoisted_6 = {
  key: 1,
  class: "label"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_uikit_input = resolveComponent("uikit-input");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode(_component_uikit_input, {
      ref: "inner",
      modelValue: $setup.query,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.query = $event),
      legend: $props.legend,
      placeholder: $props.placeholder,
      name: $props.name,
      hint: $props.hint,
      debounceValidation: 250,
      rules: $props.rules,
      disabled: $props.disabled,
      variant: $props.variant,
      validateOnValueUpdate: false,
      syncVModel: false,
      type: "text",
      autocomplete: "off",
      onKeyup: [
        withKeys(withModifiers($options.handleUpSearch, ["prevent", "stop"]), ["up"]),
        withKeys(withModifiers($options.handleDownSearch, ["prevent", "stop"]), ["down"]),
        $options.handleSearch
      ],
      onKeydown: [
        _cache[1] || (_cache[1] = withKeys(($event) => $options.handleSelection($options.highlightElement, $event), ["enter"])),
        _cache[2] || (_cache[2] = withKeys(($event) => $options.handleSelection($options.highlightElement, $event), ["tab"]))
      ],
      onFocus: $options.handleFocus,
      onBlur: $options.handleBlur
    }, createSlots({ _: 2 }, [
      _ctx.$slots.prefix ? {
        name: "prefix",
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
        ]),
        key: "0"
      } : void 0,
      _ctx.$slots.suffix ? {
        name: "suffix",
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "legend", "placeholder", "name", "hint", "rules", "disabled", "variant", "onKeyup", "onFocus", "onBlur"]),
    createVNode(Transition, { name: "search-panel" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: "search-panel",
          style: normalizeStyle(_ctx.panelStyles)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, index) => {
            return openBlock(), createElementBlock(Fragment, null, [
              option.options ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                (openBlock(), createElementBlock("div", {
                  key: "option-" + index,
                  class: "item group"
                }, [
                  renderSlot(_ctx.$slots, "option", mergeProps({ ref_for: true }, option), () => [
                    createElementVNode("span", _hoisted_2, toDisplayString(option.label), 1)
                  ], true)
                ])),
                (openBlock(true), createElementBlock(Fragment, null, renderList(option.options, (groupedOption, groupIndex) => {
                  return openBlock(), createElementBlock("div", {
                    key: "option-" + groupIndex + "-group-" + index,
                    class: normalizeClass(["item grouped", { highlight: _ctx.highlightElementIndex === groupIndex }]),
                    onMouseup: ($event) => $options.handleSelection(groupedOption, $event)
                  }, [
                    renderSlot(_ctx.$slots, "option", mergeProps({ ref_for: true }, groupedOption), () => [
                      createElementVNode("span", _hoisted_4, toDisplayString(groupedOption.label), 1)
                    ], true)
                  ], 42, _hoisted_3);
                }), 128))
              ], 64)) : (openBlock(), createElementBlock("div", {
                key: "option-" + index,
                class: normalizeClass(["item", { highlight: _ctx.highlightElementIndex === index }]),
                onMouseup: ($event) => $options.handleSelection(option, $event)
              }, [
                _ctx.$slots.option ? renderSlot(_ctx.$slots, "option", {
                  key: 0,
                  option
                }, void 0, true) : (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(option.label), 1))
              ], 42, _hoisted_5))
            ], 64);
          }), 256))
        ], 4), [
          [vShow, $options.isPanelOpened]
        ])
      ]),
      _: 3
    })
  ]);
}
const Autocomplete = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-1cc0651d"]]);
export {
  Autocomplete as default
};
//# sourceMappingURL=Autocomplete.vue.es.js.map
